import { Checkbox } from "@commonlibs";
import styled, { css } from "styled-components";

export const CheckboxRoot = styled(Checkbox)(
    () => css`
        .LabelRoot {
            column-gap: 5px;
        }
    `,
);

export const AddDenominationButton = styled.button(
    ({ theme }) => css`
        border: none;
        background: none;
        padding: 0px;
        margin: 0px;
        cursor: pointer;
        font-size: 0.75rem;
        line-height: 1.125rem;
        font-family: Montserrat;
        font-weight: 600;
        color: ${theme.palette.primary};
        text-decoration: underline;
    `,
);
